import * as PIXI from "pixi.js";
import { Point } from "../models";

export const potTotalTextTopPosition: PIXI.Point = new PIXI.Point(910, 380); // top-left
export const potTotalTextDoubleBoardPosition: PIXI.Point = new PIXI.Point(910, 305); // top-left
export const potTotalTextRightPosition: PIXI.Point = new PIXI.Point(1281, 440); // top-left
export const TableNamTextPosition: Point = { x: 960, y: 10 }; 

export const TablePosition: Point = { x: 0, y: 0 }; // y = offset from header
// export const TablePositionUnlimited: Point = { x: 960, y: 480 }; // center
export const TableShadowPosition: Point = { x: 270, y: 290 }; // top-left
export const MainPotPositions: Point[] = [
  // center
  { x: 698.1, y: 459.5 }, // center
  { x: 695, y: 565 },
  { x: 698.1, y: 459.5 }, // if it's not double board
];
export const DoubleBoardMainPotPositions: Point[] = [
  { x: 718.8, y: 381.5 },
  { x: 698.1, y: 496.4 },
];
export const FpsPosition: Point = { x: 10, y: 140 };
export const TopLeftInfoPosition: Point = { x: 960, y: 318 };

export const SexyDealerPosition: Point = { x: 960, y: 136 };
// export const SexyDealerPositionUnlimited: Point = { x: 960, y: 108 };

export const SeatsVisibility = {
  0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 0 players - NOT POSSIBLE
  1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 player - NOT POSSIBLE
  2: [0, 1, 0, 0, 0, 0, 1, 0, 0, 0], // 2 players
  3: [0, 0, 0, 1, 0, 0, 1, 0, 0, 1], // 3 players
  4: [0, 1, 0, 1, 0, 0, 1, 0, 0, 1], // 4 players
  5: [1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // 5 players
  6: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0], // 6 players
  7: [1, 0, 1, 1, 0, 1, 1, 1, 0, 1], // 7 players
  8: [1, 1, 1, 1, 0, 1, 1, 1, 1, 0], // 8 players
  9: [1, 0, 1, 1, 1, 1, 1, 1, 1, 1], // 9 players
  10: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // 10 players
};

export const SeatsVisibilityWithDealer = {
  0: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 0 players - NOT POSSIBLE
  1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 1 player - NOT POSSIBLE
  2: [0, 0, 0, 0, 1, 0, 0, 0, 1, 0], // 2 players
  3: [1, 0, 1, 0, 0, 0, 1, 0, 0, 0], // 3 players
  4: [0, 1, 0, 1, 0, 0, 1, 0, 0, 1], // 4 players
  5: [1, 0, 1, 0, 1, 0, 1, 0, 1, 0], // 5 players
  6: [1, 1, 1, 0, 0, 1, 1, 1, 0, 0], // 6 players
  7: [1, 0, 1, 1, 0, 1, 1, 1, 0, 1], // 7 players
  8: [1, 1, 1, 1, 0, 1, 1, 1, 1, 0], // 8 players
  9: [1, 0, 1, 1, 1, 1, 1, 1, 1, 1], // 9 players
  10: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1], // 10 players
};

export const SeatPositions: Point[] = [
  { x: 903, y: 673 }, // 0  local player / bottom center
  { x: 417, y: 673 }, // 1
  { x: 252, y: 591 }, // 2
  { x: 173, y: 466 }, // 3
  { x: 181, y: 326 }, // 4
  { x: 272, y: 187 }, // 5
  { x: 302, y: 156 }, // 6
  { x: 416, y: 99 }, // 7
  { x: 532, y: 99 }, // 8
  { x: 638, y: 99 }, // 9
  { x: 903, y: 99 }, // 10  top center
  { x: 1168, y: 99 }, // 11
  { x: 1275, y: 99 }, // 12
  { x: 1390, y: 99 }, // 13
  { x: 1497, y: 156 }, // 14
  { x: 1523, y: 187 }, // 15
  { x: 1618, y: 326 }, // 16
  { x: 1637, y: 466 }, // 17
  { x: 1561, y: 591 }, // 18
  { x: 1390, y: 673 }, // 19
];

export const SeatLayoutIndices: Record<number, number[]> = {
  2: [0, 10], // 2 players
  3: [0, 6, 14], // 3 players
  4: [0, 4, 10, 16], // 4 players
  5: [0, 3, 8, 12, 17], // 5 players
  6: [0, 2, 6, 10, 14, 18], // 6 players
  7: [0, 1, 4, 9, 11, 16, 19], // 7 players
  8: [0, 1, 4, 7, 10, 13, 16, 19], // 8 players
  9: [0, 1, 3, 5, 9, 11, 15, 17, 19], // 9 players
  10: [0, 1, 3, 5, 8, 10, 12, 15, 17, 19], // 10 players
};

// export const SeatPositionsUnlimited: Point[] = [
//     { x: 537, y: 143 + 12},
//     { x: 954, y: 143 + 12},
//     { x: 1371, y: 143 + 12},
//     { x: 1725, y: 331 + 12},
//     { x: 1725, y: 582 + 12}, // center
//     { x: 1371, y: 824 - 60 },
//     { x: 954, y: 824 - 60 },
//     { x: 537, y: 824 - 60 },
//     { x: 196, y: 585 + 12},
//     { x: 196, y: 332 + 12},
// ];
// export const SeatPositionsFor6PlayersUnlimited: Point[] = [
//     { x: 317, y: 193 },
//     { x: 954, y: 144 },
//     { x: 1607, y: 193 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 }, // center
//     { x: 1607, y: 720 - 60 },
//     { x: 954, y: 825 - 60 },
//     { x: 317, y: 720 - 60 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 },
// ];

// export const SeatPositionsAdvanced: Point[] = [
//     { x: 541, y: 157 },
//     { x: 958, y: 157 },
//     { x: 1367, y: 157 },
//     { x: 1621, y: 346 },
//     { x: 1621, y: 598 }, // center
//     { x: 1367, y: 838 },
//     { x: 953, y: 838 },
//     { x: 542, y: 838 },
//     { x: 301, y: 598 },
//     { x: 301, y: 346 },
// ];
// export const SeatPositionsAdvancedFor6Players: Point[] = [
//     { x: 419, y: 190 },
//     { x: 958, y: 157 },
//     { x: 1504, y: 190 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 }, // center
//     { x: 1504, y: 764 },
//     { x: 953, y: 838 },
//     { x: 419, y: 764 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 },
// ];

export const PlayerPositions: Point[] = [
  { x: 894, y: 665 }, // 0  local player / bottom center ✅
  { x: 404, y: 636 }, // 1 
  { x: 238, y: 556 }, // 2
  { x: 159, y: 440 }, // 3
  { x: 175, y: 293 }, // 4
  { x: 265, y: 157 }, // 5 
  { x: 300, y: 127 }, // 6
  { x: 399, y: 57 }, // 7
  { x: 517, y: 57 }, // 8 
  { x: 626, y: 57 }, // 9 
  { x: 894, y: 57 }, // 10  top center 
  { x: 1162, y: 57 }, // 11 
  { x: 1271, y: 57 }, // 12 
  { x: 1389, y: 57 }, // 13
  { x: 1487, y: 127 }, // 14
  { x: 1523, y: 157 }, // 15 
  { x: 1613, y: 293 }, // 16
  { x: 1629, y: 440 }, // 17 
  { x: 1549, y: 556 }, // 18
  { x: 1384, y: 636 }, // 19 
];

export const PotPositions: Point[] = [
  { x: 960, y: 630 }, // 0  local player / bottom center 
  { x: 530, y: 605 }, // 1 
  { x: 449, y: 565 }, // 2 
  { x: 430, y: 540 }, // 3 
  { x: 387, y: 476 }, // 4 
  { x: 460, y: 337 }, // 5 
  { x: 497, y: 318 }, // 6 
  { x: 537, y: 256 }, // 7 
  { x: 580, y: 255 }, // 8 
  { x: 680, y: 260 }, // 9 
  { x: 970, y: 255 }, // 10  top center 
  { x: 1240, y: 260 }, // 11 
  { x: 1340, y: 255 }, // 12 
  { x: 1383, y: 256 }, // 13 
  { x: 1423, y: 318 }, // 14 
  { x: 1460, y: 337 }, // 15 
  { x: 1533, y: 476 }, // 16 
  { x: 1490, y: 540 }, // 17 
  { x: 1471, y: 565 }, // 18 
  { x: 1380, y: 605 }, // 19 
];

export const DealerButtonPositions: Point[] = [
  { x: 1025, y: 660 }, // 0  local player / bottom center
  { x: 366, y: 625 }, // 1 
  { x: 268, y: 508 }, // 2 
  { x: 291, y: 437 }, // 3 
  { x: 261, y: 475 }, // 4 
  { x: 323, y: 337 }, // 5 
  { x: 341, y: 308 }, // 6 
  { x: 399, y: 238 }, // 7 
  { x: 656, y: 200 }, // 8 
  { x: 753, y: 215 }, // 9 
  { x: 851, y: 211 }, // 10  top center 
  { x: 1123, y: 215 }, // 11 
  { x: 1220, y: 200 }, // 12 
  { x: 1477, y: 238 }, // 13 
  { x: 1535, y: 308 }, // 14 
  { x: 1553, y: 337 }, // 15 
  { x: 1615, y: 475 }, // 16 
  { x: 1585, y: 437 }, // 17 
  { x: 1608, y: 508 }, // 18 
  { x: 1510, y: 625 }, // 19 
];

// export const PlayerPositionsUnlimited: Point[] = [
//     { x: 539, y: 129 },
//     { x: 956, y: 129 },
//     { x: 1369, y: 129 },
//     { x: 1723, y: 317 },
//     { x: 1723, y: 570 }, // center
//     { x: 1369, y: 810 - 72 },
//     { x: 956, y: 810 - 72 },
//     { x: 539, y: 810 - 72 },
//     { x: 199, y: 570 },
//     { x: 199, y: 317 },
// ];
// export const PlayerPositionsFor6PlayersUnlimited: Point[] = [
//     { x: 320, y: 179 },
//     { x: 956, y: 129 },
//     { x: 1606, y: 179 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 }, // center
//     { x: 1606, y: 705 - 72 },
//     { x: 956, y: 810 - 72 },
//     { x: 320, y: 705 - 72 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 },
// ];


export const DealerChipPositions: Point[] = [
  { x: 596, y: 265 },
  { x: 1108, y: 265 },
  { x: 1314, y: 265 },
  { x: 1486, y: 378 },
  { x: 1486, y: 551 }, // center
  { x: 1313, y: 656 },
  { x: 973, y: 660 },
  { x: 598, y: 656 },
  { x: 427, y: 576 },
  { x: 433, y: 337 },
];
export const DealerChipPositionsFor6Players: Point[] = [
  { x: 468, y: 347 },
  { x: 1106, y: 265 },
  { x: 1462, y: 347 },
  { x: 0, y: 0 },
  { x: 0, y: 0 }, // center
  { x: 1462, y: 558 },
  { x: 973, y: 660 },
  { x: 468, y: 558 },
  { x: 0, y: 0 },
  { x: 0, y: 0 },
];

// export const PotPositionsUnlimited: Point[] = [
//     { x: 667, y: 266 },
//     { x: 1036, y: 300 },
//     { x: 1242, y: 266 },
//     { x: 1456, y: 376 },
//     { x: 1456, y: 598 }, // center
//     { x: 1245, y: 660 }, // { x: 1245, y: 660 - 62 },
//     { x: 1039, y: 650 }, // { x: 1039, y: 660 - 62 },
//     { x: 667, y: 660 }, // { x: 667, y: 660 - 62 },
//     { x: 443, y: 617 },
//     { x: 443, y: 376 },
// ];
// export const PotPositionsFor6PlayersUnlimited: Point[] = [
//     { x: 493, y: 306 },
//     { x: 1036, y: 300 },
//     { x: 1438, y: 306 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 }, // center
//     { x: 1438, y: 600 - 62 },
//     { x: 1039, y: 650 }, // { x: 1039, y: 660 - 62 },
//     { x: 493, y: 600 - 62 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 },
// ];

// export const DealerChipPositionsUnlimited: Point[] = [
//     { x: 596, y: 265 },
//     { x: 858, y: 293 },
//     { x: 1314, y: 265 },
//     { x: 1486, y: 378 },
//     { x: 1486, y: 551 }, // center
//     { x: 1313, y: 656 },
//     { x: 888, y: 660 },
//     { x: 598, y: 656 },
//     { x: 427, y: 576 },
//     { x: 433, y: 337 },
// ];
// export const DealerChipPositionsFor6PlayersUnlimited: Point[] = [
//     { x: 468, y: 347 },
//     { x: 858, y: 293 },
//     { x: 1462, y: 347 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 }, // center
//     { x: 1462, y: 558 - 62 },
//     { x: 888, y: 660 },
//     { x: 468, y: 558 - 62 },
//     { x: 0, y: 0 },
//     { x: 0, y: 0 },
// ];

export const ClubLogoLeftPosition: Point = { x: 735, y: 480 };
export const ClubLogoRightPosition: Point = { x: 1185, y: 480 };
export const BrandLogoPosition: Point = { x: 960, y: 400 };

export const BlindsTextPosition: Point = { x: 960, y: 597 };
export const TournamentTimersPosition: Point = { x: 1600, y: 0 };
export const TableDescriptionTextPosition: Point = { x: 960, y: 612 - 40 };
export const TableBlindsTextPosition: Point = { x: 960, y: 612 - 5 };

export const TripleDrawInfoPosition: Point = { x: 960, y: 445 };

export const TableTextRabbitHunting: Point = { x: 960, y: 95 };
